<template>
  <div class="ctask">
    <div v-if="activeTask" class="ctask__task">
      <div class="ctask__title">АКТИВНАЯ ЗАДАЧА · T‑{{ activeTask.id }}</div>
      <div><span class="ctask__muted">Инженер:</span> <b>{{ (activeTask.assignee && activeTask.assignee.username) || '—' }}</b></div>
      <div>
        <span class="ctask__muted">Дедлайн:</span> <b>{{ isoToRu(activeTask.deadline_date) }}</b>
        <span v-if="overdue" class="ctask__badge">Просрочена</span>
      </div>
      <ul class="ctask__works">
        <li v-for="(fw, i) in (activeTask.field_works || [])" :key="i">— {{ (fw.type && fw.type.title) || '—' }}</li>
      </ul>
      <div v-if="activeTask.description" class="ctask__comment"><b class="ctask__muted">Комментарий диспетчера.</b> {{ activeTask.description }}</div>
      <div class="ctask__actions">
        <button type="button" class="btn btn-success btn-sm ctask__edit" :disabled="busy" @click="$emit('edit-task', activeTask)">Изменить</button>
        <button type="button" class="btn btn-outline-danger btn-sm ctask__cancel" :disabled="busy" @click="$emit('cancel-task', activeTask)">Отменить</button>
      </div>
      <button v-if="extraActiveCount > 0" type="button" class="btn btn-link btn-sm px-0 ctask__more" @click="$emit('show-active-tasks')">
        и ещё {{ extraActiveCount }} активных задач
      </button>
    </div>
    <div v-else-if="tasksState === 'error'" class="ctask__muted ctask__unavailable">Список задач не загрузился — действия недоступны</div>
    <div v-else-if="tasksState === 'loading'" class="ctask__muted ctask__reloading">Обновление…</div>
    <button v-else-if="canCreate" type="button" class="btn btn-success btn-block ctask__create" :disabled="busy" @click="$emit('create-task', target)">Создать задачу</button>
    <div v-else-if="stale" class="ctask__muted ctask__stale">Есть назначенная задача — обновите список</div>
  </div>
</template>

<script>
import { isoToRu, isOverdue } from '@/components/management/dispatcher/format';

/**
 * The task part of a floating card (spec §9), shared by the object card and the point card:
 * the active task with «Изменить» / «Отменить», or «Создать задачу», or why neither is available.
 */
export default {
  name: 'CardTaskBlock',
  props: {
    target: { type: Object, required: true }, // the location / point handed back with `create-task`
    activeTask: { type: Object, default: null },
    extraActiveCount: { type: Number, default: 0 },
    // 'ready' | 'loading' | 'error' — decides what an empty block says (§12)
    tasksState: { type: String, default: 'ready' },
    canCreate: { type: Boolean, default: false },
    // the target reports an assigned task that is not in the active list (dead-end guard, §9)
    stale: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  computed: {
    overdue() {
      return !!this.activeTask && isOverdue(this.activeTask.deadline_date);
    },
  },
  methods: { isoToRu },
};
</script>

<style scoped lang="scss">
.ctask { display: flex; flex-direction: column; gap: 6px; }
.ctask__muted { color: #8b918c; }
.ctask__task { background: #f2f9f6; border: 1px solid #cfe3dc; border-radius: 10px; padding: 12px; display: flex; flex-direction: column; gap: 4px; }
.ctask__title { color: #0f5a4a; font-weight: 800; font-size: 11.5px; letter-spacing: .06em; }
.ctask__badge { margin-left: 7px; background: #fbeae5; color: #c0492b; font-size: 10.5px; font-weight: 800; padding: 2px 6px; border-radius: 5px; }
.ctask__works { list-style: none; padding: 0; margin: 4px 0; }
.ctask__comment { border-top: 1px dashed #cfe3dc; padding-top: 6px; }
.ctask__actions { display: flex; gap: 8px; margin-top: 6px; }
</style>
